import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { PageLegacy } from "@silvertours/front-features";
var LayoutlessDisplay = function(param) {
    var children = param.children, page = param.page;
    /*#__PURE__*/ return _jsx(PageLegacy.PageBase, {
        isAffiliate: (page === null || page === void 0 ? void 0 : page.color) !== undefined,
        children: children
    });
};
export { LayoutlessDisplay };
